function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnetBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0046A3",
      fillOpacity: 1
    },
    d: "M 3.210938 20.789062 C 4.257812 21.835938 5.476562 22.644531 6.839844 23.199219 C 8.15625 23.730469 9.539062 24 10.960938 24 C 12.382812 24 13.769531 23.730469 15.082031 23.199219 C 16.445312 22.644531 17.664062 21.835938 18.710938 20.789062 L 20.191406 19.308594 L 15.894531 15.011719 L 14.414062 16.492188 C 13.492188 17.417969 12.265625 17.925781 10.960938 17.925781 C 9.65625 17.925781 8.429688 17.417969 7.507812 16.492188 C 5.601562 14.585938 5.601562 11.488281 7.507812 9.582031 L 8.988281 8.101562 L 4.691406 3.808594 L 3.210938 5.289062 C 2.167969 6.335938 1.355469 7.554688 0.804688 8.917969 C 0.269531 10.230469 0 11.617188 0 13.039062 C 0 14.460938 0.269531 15.847656 0.804688 17.160156 C 1.355469 18.523438 2.164062 19.746094 3.210938 20.789062 Z M 3.210938 20.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0046A3",
      fillOpacity: 1
    },
    d: "M 21.339844 11.632812 C 20.769531 11.0625 19.847656 11.0625 19.277344 11.632812 L 17.269531 13.640625 L 21.566406 17.9375 L 23.574219 15.929688 C 24.140625 15.359375 24.140625 14.4375 23.574219 13.867188 Z M 21.339844 11.632812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0046A3",
      fillOpacity: 1
    },
    d: "M 8.070312 0.429688 L 6.066406 2.4375 L 10.363281 6.734375 L 12.367188 4.726562 C 12.9375 4.15625 12.9375 3.234375 12.367188 2.660156 L 10.136719 0.429688 C 9.5625 -0.144531 8.644531 -0.144531 8.070312 0.429688 Z M 8.070312 0.429688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnetBlue);
export default __webpack_public_path__ + "static/media/magnet-blue.3ef7f8d7e737a1f5c3f5b9b24cf3349f.svg";
export { ForwardRef as ReactComponent };